// ** Redux Imports
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from '../../../services/ApiService'

// ** Types
import { CalendarFiltersType, FetchEventsFilterType, AddEventType, EventType } from 'src/types/apps/calendarTypes'

// ** Fetch Events
export const fetchEvents = createAsyncThunk('appCalendar/fetchEvents', async (args: FetchEventsFilterType) => {
  const { calendars , channels } = args;
  const response = await axios.get('content', {
    params: {
      calendars,
      channels
    }
  })

    let userEvents: EventType [] = []; 
    response.data != null && response.data.map((post: any) => {
        userEvents.push({
            id: post.id,
            url: "",//Change it later
            title: post.message,
            display: post.message,  
            end: post.scheduleTime ? post.scheduleTime : post.createdTime,
            start: post.scheduleTime ? post.scheduleTime : post.createdTime,
            allDay: false,
            extendedProps: {
                calendar: (post.errors && post.errors.length > 0) || post.status == "error" ? "Error" : post.status
            }
        })
    });
    return { events: userEvents, posts: response.data };



})

// ** Add Event
export const addEvent = createAsyncThunk('appCalendar/addEvent', async (event: AddEventType, { dispatch }) => {
  //const response = await axios.post('/apps/calendar/add-event', {
  //  data: {
  //    event
  //  }
  //})
  //await dispatch(fetchEvents(['Personal', 'Business', 'Family', 'Holiday', 'ETC']))

  //return response.data.event

    await dispatch(fetchEvents({ calendars: ['Pending', 'Scheduled', 'Delivered', 'Published', 'Error'], channels : null }))
    return event;
})

// ** Update Event
export const updateEvent = createAsyncThunk('appCalendar/updateEvent', async (event: EventType, { dispatch }) => {
  const response = await axios.post('/apps/calendar/update-event', {
    data: {
      event
    }
  })
    await dispatch(fetchEvents({ calendars: ['Pending', 'Scheduled', 'Delivered', 'Published', 'Error'], channels: null }))

  return response.data.event
})

// ** Delete Event
export const deleteEvent = createAsyncThunk('appCalendar/deleteEvent', async (id: number | string, { dispatch }) => {
  const response = await axios.delete('/apps/calendar/remove-event', {
    params: { id }
  })
    await dispatch(fetchEvents({ calendars: ['Pending', 'Scheduled', 'Delivered', 'Published', 'Error'], channels : null }))

  return response.data
})

export const appCalendarSlice = createSlice({
  name: 'appCalendar',
  initialState: {
    events: [],
    selectedEvent: null,
    selectedPost : null,
    selectedCalendars: ['Pending', 'Scheduled', 'Delivered', 'Published', 'Error'],
    posts : [],
    selectedChannels : ['']
  },
  reducers: {
    handleSelectEvent: (state, action) => {
      state.selectedEvent = action.payload
      state.selectedPost = state.selectedEvent ? current(state).posts?.filter((p : any) => p.id == state.selectedEvent?.["id"])[0] : null;
      },
      handleChannelUpdate: (state, action) => {
          if (action.payload)
          {
              state.selectedChannels = action.payload;
          }
    },
    handleCalendarsUpdate: (state, action) => {
      const filterIndex = state.selectedCalendars.findIndex(i => i === action.payload)
      if (state.selectedCalendars.includes(action.payload)) {
          state.selectedCalendars.splice(filterIndex, 1)
          //console.log(current(state.selectedCalendars));
      } else {
        state.selectedCalendars.push(action.payload)
      }
      if (state.selectedCalendars.length === 0) {
        state.events.length = 0
      }
    },
    handleAllCalendars: (state, action) => {
      const value = action.payload
      if (value === true) {
          state.selectedCalendars = ['Pending', 'Scheduled', 'Delivered', 'Published', 'Error']
      } else {
        state.selectedCalendars = []
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchEvents.fulfilled, (state, action) => {
      state.events = action.payload.events as any
      state.posts = action.payload.posts
    })
  }
})
export const { handleSelectEvent, handleCalendarsUpdate, handleAllCalendars, handleChannelUpdate } = appCalendarSlice.actions

export default appCalendarSlice.reducer
